import { z } from 'zod';
import { IsoTimestamp, SchoolId, UserId } from './common.js';
const AssignmentDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Use a YYYY-MM-DD date.').refine((value) => {
    const date = new Date(`${value}T00:00:00Z`);
    return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === value;
}, 'Invalid calendar date.');
/** Firestore: schools/{schoolId}/teachingAssignments/{id}. History is never deleted. */
export const TeachingAssignmentSource = z.enum(['local', 'integrated']);
export const TeachingAssignmentStatus = z.enum(['active', 'inactive', 'archived']);
export const TeachingAssignment = z.object({
    id: z.string().min(1).max(64),
    schoolId: SchoolId,
    teacherId: UserId,
    subjectId: z.string().min(1).max(128).regex(/^[^/]+$/),
    classroomId: z.string().min(1).max(128).regex(/^[^/]+$/),
    effectiveFrom: AssignmentDate,
    effectiveTo: AssignmentDate.nullable().optional(),
    status: TeachingAssignmentStatus.default('active'),
    source: TeachingAssignmentSource.default('local'),
    externalAssignmentId: z.string().min(1).max(128).regex(/^[^/]+$/).nullable().optional(),
    externalTeacherId: z.string().min(1).max(128).regex(/^[^/]+$/).nullable().optional(),
    externalSubjectId: z.string().min(1).max(128).regex(/^[^/]+$/).nullable().optional(),
    externalClassroomId: z.string().min(1).max(128).regex(/^[^/]+$/).nullable().optional(),
    createdAt: IsoTimestamp,
    updatedAt: IsoTimestamp,
});
export const CreateTeachingAssignmentRequest = z.object({
    teacherId: z.string().min(1).max(128).regex(/^[^/]+$/),
    subjectId: z.string().min(1).max(128).regex(/^[^/]+$/),
    classroomId: z.string().min(1).max(128).regex(/^[^/]+$/),
    effectiveFrom: AssignmentDate,
    effectiveTo: AssignmentDate.nullable().optional(),
    status: TeachingAssignmentStatus.optional(),
}).refine((value) => !value.effectiveTo || value.effectiveTo >= value.effectiveFrom, {
    message: 'effectiveTo cannot be earlier than effectiveFrom.', path: ['effectiveTo'],
});
export const UpdateTeachingAssignmentRequest = z.object({
    teacherId: z.string().min(1).max(128).regex(/^[^/]+$/).optional(),
    subjectId: z.string().min(1).max(128).regex(/^[^/]+$/).optional(),
    classroomId: z.string().min(1).max(128).regex(/^[^/]+$/).optional(),
    effectiveFrom: AssignmentDate.optional(),
    effectiveTo: AssignmentDate.nullable().optional(),
    status: TeachingAssignmentStatus.optional(),
}).refine((value) => !value.effectiveTo || !value.effectiveFrom || value.effectiveTo >= value.effectiveFrom, {
    message: 'effectiveTo cannot be earlier than effectiveFrom.', path: ['effectiveTo'],
});
//# sourceMappingURL=teaching-assignment.js.map